import {
  IMapCameraOptions,
  SimpleLayerSpecification,
  TBaseMapStyle,
  TBasemapTweak
} from '@lifk/types'

export const defaultBaseMap: TBaseMapStyle = 'light'

export const baseMapStyleUrls: Record<TBaseMapStyle, string> = {
  light: 'mapbox://styles/sphericalstudio/cmeugvmf800vv01r97ohi4j3i',
  satellite: 'mapbox://styles/sphericalstudio/cmok7k9cv001d01s7haoba562'
}

export const BasemapTweakHideGreen: TBasemapTweak = 'Hide Green'
export const BasemapTweakHideLabels: TBasemapTweak = 'Hide Labels'
export const BasemapTweakHideBuiltEnv: TBasemapTweak = 'Hide Built Environment'

const GreenLayers = [
  'national-park',
  'landcover',
  'custom_landcover',
  'landuse'
  // 'hillshade',
]

const NaturalEnvLayers = [
  'land',
  'waterway',
  'water',
  'bathymetry',
  'hillshade',
  'satellite' // For satellite basemap
]

export const BasemapTweaks = {
  [BasemapTweakHideGreen]: {
    match: (layer: SimpleLayerSpecification) =>
      GreenLayers.indexOf(layer.id) > -1
  },
  [BasemapTweakHideLabels]: {
    match: (layer: SimpleLayerSpecification) => layer.type == 'symbol'
  },
  [BasemapTweakHideBuiltEnv]: {
    // Hide all layers that are NOT part of the natural environment
    match: (layer: SimpleLayerSpecification) =>
      NaturalEnvLayers.indexOf(layer.id) === -1
  }
}

// Default map options
// function instead of const ensures a new object each time
// this allows safe mutations when used as map camera state
export const getDefaultMapOptions = (): IMapCameraOptions => ({
  center: { lng: -118.49589453776426, lat: 34.26768586974508 },
  zoom: 8.5,
  bearing: 0,
  pitch: 0
})
